'use client';

import { c as _c } from "react/compiler-runtime";
import { AppShellBootSkeleton } from '@/domains/dashboard/components/app-shell-boot-skeleton';
import { useAuthContext } from '@/hooks/use-auth';
import { isPlayground } from '@/utils/check-is-playground';
import { useRouter } from 'next/navigation';
import { PropsWithChildren, useEffect } from 'react';
import { GenericErrorPage } from '../errors';
export const AuthenticatedLayout = t0 => {
  const $ = _c(12);
  const {
    children
  } = t0;
  const {
    auth,
    loading,
    error,
    isSharedLink
  } = useAuthContext();
  let t1;
  if ($[0] !== auth) {
    t1 = !auth && !isPlayground();
    $[0] = auth;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const shouldRedirect = t1;
  const router = useRouter();
  let t2;
  let t3;
  if ($[2] !== loading || $[3] !== router || $[4] !== shouldRedirect) {
    t2 = () => {
      if (!loading && shouldRedirect) {
        router.push("/login");
      }
    };
    t3 = [shouldRedirect, router, loading];
    $[2] = loading;
    $[3] = router;
    $[4] = shouldRedirect;
    $[5] = t2;
    $[6] = t3;
  } else {
    t2 = $[5];
    t3 = $[6];
  }
  useEffect(t2, t3);
  if (loading) {
    let t4;
    if ($[7] !== isSharedLink) {
      t4 = <div className="fadeIn h-screen w-full"><AppShellBootSkeleton isSharedLink={isSharedLink} /></div>;
      $[7] = isSharedLink;
      $[8] = t4;
    } else {
      t4 = $[8];
    }
    return t4;
  }
  if (error) {
    let t4;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <GenericErrorPage />;
      $[9] = t4;
    } else {
      t4 = $[9];
    }
    return t4;
  }
  if (shouldRedirect) {
    return null;
  }
  let t4;
  if ($[10] !== children) {
    t4 = <>{children}</>;
    $[10] = children;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
};